<template>
    <b-modal :active.sync="isActive"
             has-modal-card full-screen >
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title  ">  {{ImagePlus}}
                    <span class="tag is-warning">  {{idlab}}</span>

                </p>

                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
                <p class="modal-card-title">
                    <b-button type="is-success"
                              icon-right="plus"
                              @click="addImage" > </b-button>
                </p>

                <ThumbnailImageList  :modeThumbnailImageList="modeThumbnailImageList" v-if="dataImages.length>0"
                                     :dataPassThruImageList="dataPassThruImageList"
                                     @deleteImage="deleteImage" />


            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveBtn" >Save </b-button>
            </footer>

            <UploadFiles v-if="isModalUploadFiles"
                         @close="closeAddImageAttachPlus"
                         @closeWithData="closeAddImageAttachPlusWithData" />
        </div>
    </b-modal>
</template>

<script>
    import globalconst from "../../../mixins/globalconst";
    import UploadFiles from "../../UtilsComponents/UploadFiles";
    import { getBaseURLAvartar ,  genUUID , getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'
    import ThumbnailImageList from "../../UtilsComponents/ThumbnailImageList";
    import axios from "axios";
    import {mapState} from "vuex";


    export default {
        name: "PlusImages",
        mixins:[globalconst],
        components:{
            UploadFiles,
            ThumbnailImageList
        },
        props:{
            idlab : String,
            isShowing : Boolean
        },
        computed:{
            ...mapState({
                clientIP : state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                return this.dataImages.map(dat => {
                    // console.log(dat)
                    return   { id: genUUID(5) ,
                        file : null,
                        urlTempUploaded:`${getBaseURLAvartar()}/temp/${dat.file}`,
                        title : dat.title,
                        fileNameUploaded: dat.file,
                        fresh : false  }

                })
            }
        },
        methods:{
            closeAddImageAttachPlusWithData(dat){
                if(dat.file){

                    const tmp = {
                        "file":   dat.fileNameUploaded,
                        "title":  dat.title,
                        "fresh": true
                    }
                    this.dataImages.push(tmp)
                }

                this.isModalUploadFiles = false
            },
            closeAddImageAttachPlus(){
                this.isModalUploadFiles = false
            },
            addImage(){
                this.isModalUploadFiles = true
            },
            deleteImage(fileNameUploaded){
                const member = this.dataImages.find(member => member.file === fileNameUploaded  )
                const memberIndex = this.dataImages.indexOf(member)
                this.dataImages.splice(memberIndex,1)
            },



            closeBtn(){
              this.$emit('closePlusImages')
            },
            saveBtn(){
                // dat target
                // { "idlab":"63CYTO0000000858",
                //     "ip": "127.0.0.1",
                //     "dat" : [
                //     { "path":"013874008412.png", "title_img" : ""},
                //     { "path":"021510604003.jpg", "title_img" : "test น๊ะ"}
                // ]
                // }

                var datImages = []
                for (var i = 0;i<this.dataImages.length;i++){
                    datImages.unshift({
                        path :  this.dataImages[i].file,
                        title_img : this.dataImages[i].title
                    })
                }
                const datTo = {
                    idlab : this.idlab ,
                    ip : this.clientIP ,
                    dat : datImages
                }

                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/newinsertimageplus`, datTo , getConfigAxios())
                    .then(()=>{
                        vm.isFullScreenSearching = false
                        vm.$buefy.toast.open({
                            message: 'Update data completely!',
                            type: 'is-success'
                        })
                        vm.$emit("closePlusImagesWithData")
                    })
                    .catch(err=>{
                        // console.log("err")

                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg}` ,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })


                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })






            },
        },
        data(){
            return {
                isActive : true,
                isModalUploadFiles : false,

                dataImages : [],
                modeThumbnailImageList : "edit",
            }
        },
        watch:{
            isShowing : {
                immediate : true,
                handler : function (val) {
                    if(val){
                         console.log('Plus Images Showing')
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>